import type { Translation } from 'primeng/api';

/**
 * Textos de PrimeNG en español (es-PE). El calendario toma días, meses, primer
 * día de la semana y formato de fecha solo de la configuración global: sin esto
 * se veía en inglés y con formato mm/dd/aaaa. Un componente que pasa su propio
 * `dateFormat` lo sigue respetando.
 */
export const PRIMENG_TRANSLATION_ES: Translation = {
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem',
  today: 'Hoy',
  clear: 'Limpiar',
  chooseDate: 'Elegir fecha',
  chooseYear: 'Elegir año',
  chooseMonth: 'Elegir mes',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  am: 'a. m.',
  pm: 'p. m.',
};
